import { InputLabel, OutlinedInput } from '@mui/material';
import { Controller } from 'react-hook-form';

const ControllerInput = ({
    control,
    label,
    name = "regexp",
    placeholder = undefined,
    rows = undefined,
    size = "medium",
    type = "text",
}: any & {
    label?: string;
    name?: string;
    placeholder?: number;
    rows?: number;
    size?: string;
    type?: string;
}) => {

  return (
  <>
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, value },
                fieldState: { error },
                formState,
            }) => (
                <>
                    <InputLabel htmlFor="id-regexp">{label}</InputLabel>
                    <OutlinedInput
                        id="id-regexp"
                        label={label}
                        key={name}
                        name={name}
                        placeholder={placeholder}
                        multiline
                        rows={rows}
                        size={size}
                        type={type}
                        value={value}
                        onChange={onChange}
                    />
                </>

            )}
        />
  </>
  ); 
};

export default ControllerInput;
